<!-- No Methods Available -->
@if (shouldShowNoMethodsMessage) {
<div class="flex flex-middle p-t-3 p-b-3">
    <div class="center">
        <div class="p2">{{ 'No delivery methods available for your basket' | translate }}</div>
    </div>
</div>
}

<!-- Method Selector (when multiple options available) -->
@if (shouldShowSelector) {
<radio-group name="deliveryMethod"
             [value]="selectedMethodCode"
             [(ngModel)]="selectedMethodCode"
             (change)="onMethodSelectionChange()">
    @for (method of methods; track method.code) {
    <radio2 [ngClass]="{'m-t-3' : !$first}"
            [context]="'basket'"
            [value]="method.code">
        <div radioTitle
             class="flex flex-justify-between flex-middle">
            <span class="p1">{{ method.title }}</span>
            <price [value]="method.price"
                   [useFreeLabel]="true"
                   class="p1"></price>
        </div>
    </radio2>
    }
</radio-group>
}